export default "__VITE_ASSET__Fvy3_Olo__"